import React from 'react';
import RecommendReviewDetailNavbar from '../RecommendReviewDetailNavbar';
import RecommendReviewDetailInfo from '../RecommendReviewDetailInfo';
import RecommendReviewDetailItemList from '../RecommendReviewDetailItemList';
import './RecommendReviewDetailWrap.scss';

const RecommendReviewDetailWrap = (props) => {
  const { recommendReviewDetail } = props;
  const { recommendReviewInfo, recommendReviewItemList } = recommendReviewDetail;

  return (
    <div className="recommend-review-detail-wrap">
      {/* 하단 네브바 */}
      <RecommendReviewDetailNavbar recommendReviewId={recommendReviewInfo.recommendReviewId} />

      {/* 추천 상품 후기 정보 */}
      <RecommendReviewDetailInfo recommendReviewInfo={recommendReviewInfo} />

      {/* 추천 상품 후기 아이템 리스트*/}
      <RecommendReviewDetailItemList recommendReviewItemList={recommendReviewItemList} />
    </div>
  );
};

export default RecommendReviewDetailWrap;
